import React from 'react';
import { Field } from 'react-final-form';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation-10';
import { IMaskMixin } from 'react-imask';
import { FieldValidator } from '../../../validation/validation';
import { PHONE } from '../../../constants/formFieldNames';

// The "size" and "as" props that come from the IMaskMixin have type definitions that are
// different than the "size" and "as" props that the Input component accept, so we don't
// want to spread those props into the Input component.
const MaskedPhoneInput = IMaskMixin<HTMLInputElement>(({ inputRef, size, as, ...props }) => (
  <Input {...props} ref={inputRef} placeholder="(XXX) XXX-XXXX" />
));

export default function PhoneNumberField() {
  return (
    <Field
      name={PHONE}
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);
        const { onChange, ...restInput } = input;
        return (
          <FormField
            error={isInvalid}
            label={<Label>Phone number</Label>}
            control={
              <MaskedPhoneInput mask="(000) 000-0000" onAccept={(value: unknown) => onChange(value)} {...restInput} />
            }
            description={
              isInvalid ? (
                <FormHelp>{error}</FormHelp>
              ) : (
                <FormHelp>This number must be able to receive text messages</FormHelp>
              )
            }
          />
        );
      }}
      validate={(phoneNumber: string) => {
        // Remove all non-numeric characters
        const sanitizedPhoneNumber = phoneNumber?.replace(/\D/g, '');
        const errors = new FieldValidator(sanitizedPhoneNumber)
          .required('Enter a valid phone number')
          .length(10, 'Phone number must be exactly 10 digits')
          .isUSPhoneNumber('Enter a valid US phone number')
          .build();

        return errors ? errors : null;
      }}
    />
  );
}
